import { HStack } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { Select } from 'Molecules';
import { Input } from 'Atoms';

interface TableFiltersProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
  selectedFramework: string;
  setSelectedFramework: (value: string) => void;
  selectedType: string;
  setSelectedType: (value: string) => void;
  selectedSubcategory: string;
  setSelectedCategory: (value: string) => void;
  frameworkOptions: Array<{ label: string; value: string }>;
  typeOptions: Array<{ label: string; value: string }>;
  subcategoryOptions: Array<{ label: string; value: string }>;
  isDrView: boolean;
}

export const TableFilters: React.FC<TableFiltersProps> = ({
  searchValue,
  setSearchValue,
  selectedFramework,
  setSelectedFramework,
  selectedType,
  setSelectedType,
  selectedSubcategory,
  setSelectedCategory,
  frameworkOptions,
  typeOptions,
  subcategoryOptions,
  isDrView,
}) => {
  return (
    <HStack gap="8px" width="100%">
      <Input
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder="Filter"
        leftIcon={<SearchIcon boxSize={'16px'} color="text.muted" />}
        inputGroupWidth="auto"
      />
      <Select
        width="180px"
        value={{ label: `Framework: ${selectedFramework}`, value: selectedFramework }}
        onChange={(val) => setSelectedFramework(val?.value ?? '')}
        isSearchable={false}
        options={frameworkOptions}
      />
      <Select
        width="180px"
        value={{ label: `Type: ${selectedType}`, value: selectedType }}
        onChange={(val) => setSelectedType(val?.value ?? '')}
        isSearchable={false}
        options={typeOptions}
      />
      {isDrView && (
        <Select
          width="180px"
          value={{ label: `Sub-category: ${selectedSubcategory}`, value: selectedSubcategory }}
          onChange={(val) => setSelectedCategory(val?.value ?? '')}
          isSearchable={false}
          options={subcategoryOptions}
        />
      )}
    </HStack>
  );
};
